import { render, staticRenderFns } from "./by-code.vue?vue&type=template&id=e522f2b8"
import script from "./by-code.vue?vue&type=script&lang=js"
export * from "./by-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports